import React, { Fragment } from 'react';
import { Button, ButtonGroup } from 'reactstrap';
import PropTypes from 'prop-types';

const Option = ({ handleConfigDataChange, selectedValue, option, name, metricName }) => {
  const isSelected = selectedValue && (selectedValue == option.value);
  const optionStyle = isSelected ? "selected-option" : "";
  return (
    <Button className={`option-title ${optionStyle}`} onClick={() => handleConfigDataChange(metricName, name, option.value)}>
      {option.label}
    </Button>
  );
}

Option.propTypes = {
  handleConfigDataChange: PropTypes.func.isRequired,
  selectedValue: PropTypes.string,
  option: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string
  }).isRequired,
  name: PropTypes.string.isRequired,
  metricName: PropTypes.string.isRequired
};

Option.defaultProps = {
  selectedValue: ''
};

const OptionList = ({ title, name, options, handleConfigDataChange, value, metricName }) => {
  const selectedValue = value && value[name];
  const optionList = options.map((option, index) => (
    <Option
      key={index}
      handleConfigDataChange={handleConfigDataChange}
      metricName={metricName}
      name={name}
      selectedValue={selectedValue}
      option={option}
    />));

  return (
    <Fragment>
      <div key={title} className="row config-container align-items-center">
        <div className="config-title mr-3">
          {title}
        </div>
        <ButtonGroup className="options-list">
          {optionList}
        </ButtonGroup>
      </div>
      <hr />
    </Fragment>
  );
}

OptionList.propTypes = {
  title: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string
    })
  ),
  handleConfigDataChange: PropTypes.func.isRequired,
  value: PropTypes.shape({
    name: PropTypes.string
  }),
  metricName: PropTypes.string.isRequired
};

OptionList.defaultProps = {
  options: []
};

export default OptionList;



// WEBPACK FOOTER //
// ./src/components/dashboard/metrics-list/OptionList.js